import 'bootstrap';
import $ from './utils/jquery-global';
// import Swiper, {Navigation, Pagination} from 'swiper';
import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
// import flatpickr from 'flatpickr';
import 'lazysizes';

// owl.carousel (js/PLUGINS/OwlCarousel2-2.3.4) n'est pas un module UMD : il
// s'attache directement a window.jQuery/window.$ (cf. sa derniere ligne
// "})(window.Zepto || window.jQuery, ...)"), d'ou "owlIcons.owlCarousel is
// not a function" tant que ces globales ne sont pas definies avant son
// execution - cf. utils/jquery-global.js, importe juste au-dessus.
import '../js/PLUGINS/OwlCarousel2-2.3.4/dist/owl.carousel.js';

// gsap.to(..., {scrollTo: ...}) est utilise un peu partout (onglet.js, product.js,
// common.js, transfers.js...) mais le plugin n'etait enregistre que dans cmd.js,
// donc ces scrolls ne faisaient rien en dehors du tunnel de paiement.
gsap.registerPlugin(ScrollToPlugin);

// UTILS
import common from './utils/common';
import ajaxRequest from './utils/ajax';
import navigatorUtils from './utils/navigator';
import menu from './utils/menu';
import assistant from './utils/assistant';

window.navigatorUtils = navigatorUtils;

// PAGES
import home from './pages/home';
import results from './pages/results';
import product from './pages/product';
import cmd from './pages/cmd';
import transfers from './pages/transfers';
import about from './pages/about';
import others from './pages/others';
import newsletter from './pages/newsletter';
import blog from './pages/blog';
import faq from './pages/faq';
import mobile from './utils/mobile';

$(document).ready(() => {

	// APPELS PRINCIPAUX
	common.init();
	menu.init();
	mobile.init();
	assistant.init();

	// GESTION PAGES
	const main = $("main").data("namespace");

	switch (main) {
		case "home":
			home.init();
			break;
		case "product":
			product.init();
			break;
		case "cmd":
			cmd.init();
			break;
		case "transfers":
			transfers.init();
			break;
		case "results":
			results.init();
			break;
		case "about":
			about.init();
			break;
		case "others":
			others.init();
			break;
		case "newsletter":
			newsletter.init();
			break;
		case "blog":
			blog.init();
			break;
		case "faq":
			faq.init();
			break;
	}

});


